<template>
  <div class="otp-verification">
    <input
      v-for="(digit, index) in otp"
      :key="index"
      v-model="otp[index]"
      ref="otpInput"
      @input="handleInput(index + 1)"
      @keydown="handleKeyDown(index, $event)"
      maxlength="1"
      type="number"
    />
  </div>
</template>

<script>
export default {
	name: "input-otp",
  props: {
    modelValue: String,
  },
  data() {
    return {
      otp: ['', '', '', ''],
    };
  },
  watch: {
    modelValue(newValue) {
      if (newValue.length === 4) {
        this.otp = newValue.split('');
      } else {
        this.otp = ['', '', '', ''];
      }
    },
  },
  methods: {
    handleInput(index) {
      if (this.otp[index - 1] !== '') {
        if (index < 4) {
          this.$refs.otpInput[index].focus();
        } else {
          this.$emit('input', this.otp.join(''));
        }
      }
    },
    handleKeyDown(index, event) {
      if (event.key === 'Backspace' && index > 0 && this.otp[index] === '') {
        this.$refs.otpInput[index - 1].focus();
        event.preventDefault();
      } else if (
        event.key.match(/[0-9]/) &&
        index < 3 &&
        this.otp[index] !== ''
      ) {
        event.preventDefault();
        this.$refs.otpInput[index + 1].focus();
      } else if (event.key === 'ArrowLeft' && index > 0) {
        this.$refs.otpInput[index - 1].focus();
      }
    },
  },
};
</script>

<style scoped>
.otp-verification {
  display: flex;
  justify-content: space-between;
}

input {
  width: 2rem;
  height: 2rem;
  text-align: center;
  font-size: 1.2rem;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  appearance: textfield;
  -moz-appearance: textfield;
  /* Firefox */
}

</style>
